import type { SportsApi } from "@/v2/api/metadata/sports";
import { FilterType, type Filter } from "@/v2/framework/filter/types";
import type { BackofficeContext } from "@/v2/framework/context/types";

import { categoryGamesStatusOptions, categoryStatusOptions } from "../shared";

export function createFilters(options: {
  ctx: BackofficeContext;
  sportsApi: SportsApi;
}): Filter[] {
  const { ctx, sportsApi } = options;

  return [
    {
      key: "status",
      label: "common.labels.status",
      placeholder: "common.labels.status",
      filterType: FilterType.Select,
      syncRouteQuery: true,
      options: categoryStatusOptions,
      multiple: true,
    },
    {
      key: "prematchGameStatus",
      label: "common.labels.prematch_status",
      placeholder: "common.labels.prematch_status",
      filterType: FilterType.Select,
      syncRouteQuery: true,
      options: categoryGamesStatusOptions,
      multiple: true,
    },
    {
      key: "liveGameStatus",
      label: "common.labels.live_status",
      placeholder: "common.labels.live_status",
      filterType: FilterType.Select,
      syncRouteQuery: true,
      options: categoryGamesStatusOptions,
      multiple: true,
    },
    {
      key: "sportId",
      label: "common.labels.sport",
      placeholder: "common.labels.sport",
      filterType: FilterType.Select,
      syncRouteQuery: true,
      options: async () => {
        const sports = await sportsApi.getFilters({ page: 1, size: -1 });
        return sports.map((sport) => ({
          value: sport.id,
          title: String(sport.name ?? ""),
        }));
      },
      searchable: true,
      multiple: true,
    },
    {
      key: "language",
      label: "common.labels.language",
      placeholder: "common.labels.language",
      filterType: FilterType.Select,
      syncRouteQuery: true,
      options: async () =>
        ctx.read.languages().map((language) => ({
          value: language.code,
          title: `languages.${language.code}`,
        })),
      multiple: false,
      searchable: true,
    },
  ];
}
